(() => {
  if (window.__ss26GolfGridTabsV4LessVariantInitialised) return;
  window.__ss26GolfGridTabsV4LessVariantInitialised = true;

  const rootSelector = '[data-ss26-grid-tabs]';
  const ui = (root, key, values = {}) => {
    const name = 'ui' + key[0].toUpperCase() + key.slice(1);
    let text = root.dataset[name] || '';
    Object.entries(values).forEach(([key, value]) => { text = text.replaceAll('{'+key+'}', String(value)); });
    return text;
  };
  const tabSelector = '[data-ss26-filter]';
  const genderSelector = '[data-ss26-gender]';
  const controlSelector = `${genderSelector}, ${tabSelector}`;
  const lookFilterSelector = '[data-ss26-look-filter]';
  const contentId = 'CollectionAjaxContent';
  const swatchSelector = '[data-ss26-card-swatch]';
  const cardSelector = '[data-ss26-product-card]';
  const editorialSelector = '.ss26-editorial-tile';
  const loadMoreSelector = '[data-ss26-load-more]';
  const evergreenMobileBatchSize = 4;
  const evergreenDesktopBatchSize = 8;
  const evergreenInitialVisibleLimit = 14;
  const evergreenAllStopHandle = '高爾夫禮盒組-男女-黑';
  const aw26ManualOrder = new Map([
    'polo-釘釦款-長袖-男',
    'polo-拉鍊款-長袖-男',
    'polo-釘釦款-長袖-女',
    'polo-拉鍊款-長袖-女',
    '女九分窄管長褲-女'
  ].map((handle, index) => [handle, index]));
  const getEvergreenBatchSize = () => window.matchMedia('(min-width: 750px)').matches
    ? evergreenDesktopBatchSize
    : evergreenMobileBatchSize;
  const cache = new Map();
  const listingIndex = new Map();
  const editorialLibrary = new Map();
  const extraProductLibraries = new Map();
  let activeRequest;
  let requestSequence = 0;
  let lastTouchActivation = 0;
  let keyboardActivationTimer;
  let merchandisingManifest;

  const getRoot = () => document.querySelector(rootSelector);
  const getTabs = (root) => Array.from(root.querySelectorAll(tabSelector));
  const getGenderTabs = (root) => Array.from(root.querySelectorAll(genderSelector));
  const getVisibleControls = (root, selector) => Array.from(root.querySelectorAll(selector)).filter((control) => !control.hidden);
  const isTwoTierNavigation = (root) => root?.dataset.ss26FilterLayout === 'gender-category';
  const desktopPointer = () => window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
  const isEvergreenMerchandising = (root) => root?.dataset.ss26MerchandisingMode === 'evergreen-recency';

  const getMerchandisingManifest = (root) => {
    if (merchandisingManifest) return merchandisingManifest;

    const manifestNode = root?.querySelector('[data-ss26-merchandising-manifest]');
    let manifest = {};
    try {
      manifest = JSON.parse(manifestNode?.textContent || '{}');
    } catch (_error) {
      manifest = {};
    }

    merchandisingManifest = {
      ss26ManualOrder: new Map(
        (Array.isArray(manifest.ss26ManualOrder) ? manifest.ss26ManualOrder : [])
          .map((handle, index) => [handle, index])
      )
    };
    return merchandisingManifest;
  };

  const getMerchandisingCards = (grid) => Array.from(grid?.children || []).filter((child) => (
    child.matches(cardSelector) || child.matches('.grid-product[data-product-handle]')
  ));

  const getEvergreenInitialVisibleCount = (cards, root) => {
    const filter = root?.dataset.ss26ActiveFilter || 'all';
    if (filter === 'all') {
      const stopIndex = cards.findIndex((card) => (
        card.dataset.productHandle === evergreenAllStopHandle
      ));
      if (stopIndex >= 0) return stopIndex + 1;
    }
    return Math.min(evergreenInitialVisibleLimit, cards.length);
  };

  const ensureEditorialStyles = (root) => {
    if (!isEvergreenMerchandising(root) || document.getElementById('ss26-editorial-tile-styles')) return;

    const style = document.createElement('style');
    style.id = 'ss26-editorial-tile-styles';
    style.textContent = `.ss26-editorial-grid-item { margin-bottom: 24px; }
.ss26-editorial-tile { position: relative; display: block; overflow: hidden; background: rgb(38, 49, 44); color: rgb(255, 255, 255); text-decoration: none; isolation: isolate; }
.ss26-editorial-tile__media { position: relative; display: block; width: 100%; aspect-ratio: 16 / 9; overflow: hidden; background: rgb(51, 65, 57); }
.ss26-editorial-tile--motion .ss26-editorial-tile__media { aspect-ratio: 16 / 9; }
.ss26-editorial-tile__image, .ss26-editorial-tile__video, .ss26-editorial-tile__shade { position: absolute; inset: 0; width: 100%; height: 100%; }
.ss26-editorial-tile__image, .ss26-editorial-tile__video { object-fit: cover; object-position: center center; transition: transform 0.52s; }
.ss26-editorial-tile__video { z-index: 1; }
.ss26-editorial-tile__image--backdrop { opacity: 0.72; filter: blur(18px) saturate(0.8); transform: scale(1.1); }
.ss26-editorial-tile__image--feature-fit { z-index: 1; right: auto; left: 50%; width: 60%; object-fit: cover; object-position: center center; box-shadow: rgba(255, 255, 255, 0.12) 0 0 0 1px; transform: translate(-50%); }
.ss26-editorial-tile__shade { z-index: 2; background: linear-gradient(90deg, rgba(24, 34, 28, 0.42), rgba(24, 34, 28, 0.11) 68%, rgba(24, 34, 28, 0.02)), linear-gradient(rgba(24, 34, 28, 0.01) 28%, rgba(24, 34, 28, 0.74)); }
.ss26-editorial-tile__copy { position: absolute; z-index: 3; right: 18px; bottom: 18px; left: 18px; display: flex; flex-direction: column; align-items: flex-start; }
.ss26-editorial-tile__kicker { margin-bottom: 7px; color: rgba(255, 255, 255, 0.78); font-size: 9px; font-weight: 680; line-height: 1.2; letter-spacing: 0.15em; }
.ss26-editorial-tile__heading { max-width: 16ch; color: inherit; font-family: Nunito, sans-serif; font-size: clamp(23px, 7vw, 34px); font-weight: 520; line-height: 1.05; letter-spacing: -0.04em; }
.ss26-editorial-tile__text { max-width: 34rem; margin-top: 8px; color: rgba(255, 255, 255, 0.8); font-size: 12px; line-height: 1.55; }
.ss26-editorial-tile__button { display: inline-flex; align-items: center; gap: 16px; margin-top: 14px; padding-bottom: 6px; border-bottom: 1px solid rgba(255, 255, 255, 0.52); font-size: 9px; font-weight: 680; line-height: 1.2; letter-spacing: 0.12em; }
.ss26-editorial-tile__button > span { color: var(--ss26-editorial-accent); }
.ss26-editorial-tile:focus-visible { outline: rgb(128, 108, 75) solid 2px; outline-offset: 4px; }
@media screen and (min-width: 750px) {
  .ss26-editorial-grid-item { margin-bottom: 32px; }
  .ss26-editorial-tile__media, .ss26-editorial-tile--motion .ss26-editorial-tile__media { aspect-ratio: 16 / 9; }
  .ss26-editorial-tile__copy { right: 22px; bottom: 22px; left: 22px; }
  .ss26-editorial-tile__heading { font-size: clamp(23px, 2.3vw, 38px); }
  .ss26-editorial-tile__kicker, .ss26-editorial-tile__button { font-size: 11px; }
  .ss26-editorial-tile__text { font-size: 14px; }
  .ss26-editorial-tile__image--feature-fit { width: 50%; }
  .ss26-editorial-grid-item--feature .ss26-editorial-tile__heading, .ss26-editorial-grid-item--lifestyle .ss26-editorial-tile__heading { font-size: clamp(20px, 1.75vw, 29px); }
}
@media (hover: hover) {
  .ss26-editorial-tile:hover .ss26-editorial-tile__image:not(.ss26-editorial-tile__image--feature-fit, .ss26-editorial-tile__image--backdrop), .ss26-editorial-tile:hover .ss26-editorial-tile__video { transform: scale(1.025); }
  .ss26-editorial-tile:hover .ss26-editorial-tile__image--feature-fit { transform: translate(-50%) scale(1.025); }
  .ss26-editorial-tile:hover .ss26-editorial-tile__image--backdrop { transform: scale(1.135); }
}
@media (prefers-reduced-motion: reduce) {
  .ss26-editorial-tile__video { display: none; }
  .ss26-editorial-tile__image, .ss26-editorial-tile__video { transition: none; }
}`;
    document.head.appendChild(style);
  };

  const getCardSortTags = (card) => new Set(
    (card.dataset.golfSortTags || '')
      .split(',')
      .map((tag) => tag.trim().toLowerCase())
      .filter(Boolean)
  );

  const getCardCohortPriority = (card, manifest) => {
    const handle = card.dataset.productHandle;
    const tags = getCardSortTags(card);
    if (tags.has('aw26-golf')) return 4;
    if (card.dataset.ss26ExtraStyling === 'true') return 0.5;
    if (card.dataset.ss26ExtraFeatured === 'true') return 3.5;
    if (manifest.ss26ManualOrder.has(handle) || tags.has('ss26-golf')) return 3;
    if (tags.has('okgolf')) return 2;
    if (tags.has('golf-2025')) return 1;
    return 0;
  };

  const sortMerchandisingCards = (cards, root) => {
    if (!isEvergreenMerchandising(root) || cards.length < 2) return cards;

    const manifest = getMerchandisingManifest(root);
    const sourceOrder = new Map(cards.map((card, index) => [card, index]));
    return [...cards].sort((cardA, cardB) => {
      const priorityA = getCardCohortPriority(cardA, manifest);
      const priorityB = getCardCohortPriority(cardB, manifest);
      if (priorityA !== priorityB) return priorityB - priorityA;

      if (priorityA === 4) {
        const rankA = aw26ManualOrder.get(cardA.dataset.productHandle) ?? Number.MAX_SAFE_INTEGER;
        const rankB = aw26ManualOrder.get(cardB.dataset.productHandle) ?? Number.MAX_SAFE_INTEGER;
        if (rankA !== rankB) return rankA - rankB;
      }
      if (priorityA === 3) {
        const rankA = manifest.ss26ManualOrder.get(cardA.dataset.productHandle) ?? Number.MAX_SAFE_INTEGER;
        const rankB = manifest.ss26ManualOrder.get(cardB.dataset.productHandle) ?? Number.MAX_SAFE_INTEGER;
        if (rankA !== rankB) return rankA - rankB;
      }

      const publishedAtA = Number(cardA.dataset.golfPublishedAt) || 0;
      const publishedAtB = Number(cardB.dataset.golfPublishedAt) || 0;
      if (publishedAtA !== publishedAtB) return publishedAtB - publishedAtA;
      return sourceOrder.get(cardA) - sourceOrder.get(cardB);
    });
  };

  const sortMerchandisingGrid = (grid, root) => {
    if (!grid || !isEvergreenMerchandising(root)) return;

    const children = Array.from(grid.children);
    const cards = getMerchandisingCards(grid);
    const sortedCards = sortMerchandisingCards(cards, root);
    let cardIndex = 0;
    grid.replaceChildren(...children.map((child) => (
      cards.includes(child) ? sortedCards[cardIndex++] : child
    )));
  };

  const setStatus = (root, message) => {
    const status = root.querySelector('[data-ss26-grid-status]');
    if (status) status.textContent = message;
  };

  const applyEvergreenProgressiveReveal = (content, root, label, requestedVisible) => {
    if (!isEvergreenMerchandising(root)) return null;

    const grid = content.querySelector('.product-grid-container');
    const cards = getMerchandisingCards(grid);
    const totalCount = cards.length;
    const batchSize = getEvergreenBatchSize();
    const initialVisible = getEvergreenInitialVisibleCount(cards, root);
    const targetVisible = Number.isFinite(requestedVisible) ? requestedVisible : initialVisible;
    const visibleCount = Math.min(
      Math.max(targetVisible, Math.min(batchSize, totalCount)),
      totalCount
    );

    cards.forEach((card, index) => {
      const hidden = index >= visibleCount;
      card.toggleAttribute('hidden', hidden);
      card.toggleAttribute('data-ss26-progressive-hidden', hidden);
    });

    grid?.querySelectorAll('.ss26-editorial-grid-item[data-ss26-editorial-position]').forEach((tile) => {
      const requestedPosition = Number(tile.dataset.ss26EditorialPosition) || batchSize;
      const revealAt = totalCount > 0 ? Math.min(requestedPosition, totalCount) : 0;
      const hidden = revealAt > visibleCount;
      tile.toggleAttribute('hidden', hidden);
      tile.toggleAttribute('data-ss26-progressive-hidden', hidden);
    });

    content.querySelectorAll('[data-ss26-load-more-wrap]').forEach((wrapper) => wrapper.remove());
    if (grid && visibleCount < totalCount) {
      const wrapper = document.createElement('div');
      const button = document.createElement('button');
      wrapper.className = 'ss26-grid-tabs__load-more';
      wrapper.dataset.ss26LoadMoreWrap = '';
      button.className = 'ss26-grid-tabs__load-more-button';
      button.type = 'button';
      button.dataset.ss26LoadMore = '';
      button.textContent = ui(root, 'more');
      button.setAttribute('translate', 'no');
      button.setAttribute('aria-label', ui(root, 'moreAria', {shown: visibleCount, total: totalCount}));
      wrapper.appendChild(button);
      grid.after(wrapper);
    }

    root.dataset.ss26VisibleProductCount = String(visibleCount);
    root.dataset.ss26TotalProductCount = String(totalCount);
    setStatus(root, ui(root, 'shown', {label, shown: visibleCount, total: totalCount}));
    return { totalCount, visibleCount };
  };

  const track = (eventName, parameters = {}) => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({ event: eventName, ...parameters });
  };

  const getEffectiveFilter = (gender, category) => category === 'all' ? gender : category;

  const getActiveState = (root) => {
    const activeFilter = root?.dataset.ss26ActiveFilter || 'all';
    const inferredGender = activeFilter === 'men' || activeFilter === 'women' ? activeFilter : 'all';
    const inferredCategory = inferredGender === 'all' ? activeFilter : 'all';
    return {
      gender: isTwoTierNavigation(root) ? (root.dataset.ss26ActiveGender || inferredGender) : 'all',
      category: isTwoTierNavigation(root) ? (root.dataset.ss26ActiveCategory || inferredCategory) : activeFilter
    };
  };

  const syncCategoryAvailability = (root, gender) => {
    getTabs(root).forEach((tab) => {
      const supported = (tab.dataset.ss26Genders || '').split(',').filter(Boolean);
      const hidden = gender !== 'all' && supported.length > 0 && !supported.includes(gender);
      tab.hidden = hidden;
      tab.setAttribute('aria-hidden', String(hidden));
    });
  };

  const setActiveState = (root, requestedGender, requestedCategory) => {
    const content = document.getElementById(contentId);
    const gender = isTwoTierNavigation(root) ? requestedGender : 'all';
    let category = requestedCategory === 'styling' ? 'new' : requestedCategory;

    syncCategoryAvailability(root, gender);
    const categoryTab = getTabs(root).find((tab) => tab.dataset.ss26Filter === category && !tab.hidden)
      || getTabs(root).find((tab) => tab.dataset.ss26Filter === 'all');
    category = categoryTab?.dataset.ss26Filter || 'all';

    let activeGenderTab;
    getGenderTabs(root).forEach((tab) => {
      const isActive = tab.dataset.ss26Gender === gender;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive) activeGenderTab = tab;
    });

    getTabs(root).forEach((tab) => {
      const isActive = tab.dataset.ss26Filter === category;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    const effectiveFilter = getEffectiveFilter(gender, category);
    root.dataset.ss26ActiveGender = gender;
    root.dataset.ss26ActiveCategory = category;
    root.dataset.ss26ActiveFilter = effectiveFilter;
    root.dataset.ss26FilterState = `${gender}:${category}`;
    if (content && categoryTab) content.setAttribute('aria-labelledby', categoryTab.id || activeGenderTab?.id || '');
    return { gender, category, effectiveFilter, categoryTab, activeGenderTab };
  };

  const getStateLabel = (root, gender, category) => {
    const genderLabels = { all: ui(root, 'all'), men: ui(root, 'men'), women: ui(root, 'women') };
    const categoryLabel = getTabs(root).find((tab) => tab.dataset.ss26Filter === category)?.textContent.trim() || 'ALL';
    if (category === 'all') return genderLabels[gender] || categoryLabel;
    if (gender === 'all') return categoryLabel;
    return `${genderLabels[gender]} · ${categoryLabel}`;
  };

  const normalizeListingValue = (value) => value?.trim().toLowerCase() || '';
  const normalizeListingTitle = (value) => normalizeListingValue(value).replace(/\s+/g, '');
  const getCardPresentation = (card) => normalizeListingValue(
    card.dataset.ss26ExtraGender || card.dataset.context || card.dataset.fusionPresentation || ''
  );

  const prepareCardListing = (card) => {
    if (card.dataset.ss26ListingPrepared === 'true') return;

    const title = card.querySelector('.grid-product__title, .ss26-look-product__title')?.textContent;
    const descriptor = card.querySelector('.ss26-product-card__descriptor, .ss26-look-product__label')?.textContent;
    const descriptorParts = descriptor?.split('·').map((part) => part.trim()) || [];
    const colour = card.querySelector('[data-ss26-card-color]')?.dataset.nativeLabel || card.querySelector('[data-ss26-card-color]')?.textContent || descriptorParts[1];
    const image = card.querySelector('[data-ss26-card-primary-media] img');
    const link = card.querySelector('[data-ss26-card-link]');

    card.dataset.ss26ListingFamily = `${normalizeListingTitle(title)}::${normalizeListingValue(descriptorParts[0])}`;
    card.dataset.ss26ListingColour = normalizeListingValue(colour);
    card.dataset.ss26ListingImage = image?.getAttribute('data-src') || image?.getAttribute('src') || '';
    card.dataset.ss26ListingUrl = link?.getAttribute('href') || '';
    card.dataset.ss26ListingPrepared = 'true';
  };

  const registerCardListing = (card) => {
    prepareCardListing(card);
    const family = card.dataset.ss26ListingFamily;
    const colour = card.dataset.ss26ListingColour;
    if (!family || !colour) return;

    listingIndex.set(`${family}::${getCardPresentation(card)}::${colour}`, {
      imageUrl: card.dataset.ss26ListingImage,
      productUrl: card.dataset.ss26ListingUrl
    });
  };

  const prepareCardListings = (scope) => {
    scope.querySelectorAll(cardSelector).forEach(registerCardListing);
  };

  const registerEditorialTiles = (scope) => {
    scope.querySelectorAll('.ss26-editorial-grid-item[data-ss26-editorial-id]').forEach((tile) => {
      editorialLibrary.set(tile.dataset.ss26EditorialId, tile.cloneNode(true));
    });
  };

  const registerExtraProducts = () => {
    document.querySelectorAll('template[data-ss26-extra-products]').forEach((template) => {
      const filters = (template.dataset.ss26ExtraProducts || '').split(',').map((value) => value.trim()).filter(Boolean);
      const gender = template.dataset.ss26ExtraGender || 'all';
      const cards = Array.from(template.content.querySelectorAll(cardSelector));
      cards.forEach((card) => {
        card.dataset.ss26ExtraGender = gender;
        card.dataset.ss26ExtraFeatured = filters.includes('all') ? 'true' : 'false';
        card.dataset.ss26ExtraStyling = filters.includes('styling') ? 'true' : 'false';
        registerCardListing(card);
      });
      filters.forEach((filter) => {
        const existing = extraProductLibraries.get(filter) || [];
        extraProductLibraries.set(filter, existing.concat(cards.map((card) => card.cloneNode(true))));
      });
    });
  };

  const getEditorialTiles = (filter) => {
    const aw26Template = document.querySelector('template[data-aw26-editorial]');
    const aw26Tile = aw26Template?.content.querySelector('[data-ss26-editorial-id]');
    if (aw26Tile) editorialLibrary.set('aw26-film', aw26Tile.cloneNode(true));
    const matchingTiles = Array.from(editorialLibrary.values()).filter((tile) => {
      const filters = tile.dataset.ss26EditorialFilters?.split(',') || [];
      return filter === 'all' ? filters.includes('all') : filters.includes(filter);
    });

    return matchingTiles
      .sort((tileA, tileB) => Number(tileA.dataset.ss26EditorialPosition) - Number(tileB.dataset.ss26EditorialPosition))
      .map((tile, index) => ({
        tile: tile.cloneNode(true),
        position: filter === 'all' ? Number(tile.dataset.ss26EditorialPosition) : (index + 1) * 4
      }));
  };

  const resolveSwatchTarget = (swatch) => {
    const card = swatch.closest(cardSelector);
    const colour = swatch.dataset.ss26SwatchColor;
    if (!card) return {};

    registerCardListing(card);
    const matchingListing = listingIndex.get(
      `${card.dataset.ss26ListingFamily}::${getCardPresentation(card)}::${normalizeListingValue(colour)}`
    );
    const renderedProductUrl = swatch.dataset.ss26SwatchUrl || swatch.getAttribute('href');
    const isCompleteLookCard = card.classList.contains('ss26-look-product');

    return {
      colour,
      imageUrl: card.dataset.catalogSource === 'profile-v1' ? swatch.dataset.ss26SwatchImage : matchingListing?.imageUrl || swatch.dataset.ss26SwatchImage,
      productUrl: isCompleteLookCard || card.dataset.catalogSource === 'profile-v1'
        ? renderedProductUrl || matchingListing?.productUrl
        : matchingListing?.productUrl || renderedProductUrl
    };
  };

  const syncCardColourText = (card, colour) => {
    if (!colour) return;

    const colourLabel = card.querySelector('[data-ss26-card-color]');
    if (colourLabel) colourLabel.textContent = colour;
    if (!card.classList.contains('ss26-look-product')) return;

    const lookLabel = card.querySelector('.ss26-look-product__label');
    if (!lookLabel) return;

    const configuredPrefix = lookLabel.dataset.ss26LookLabelPrefix
      || lookLabel.textContent.split('·')[0]?.trim()
      || '';
    lookLabel.dataset.ss26LookLabelPrefix = configuredPrefix;
    lookLabel.textContent = configuredPrefix ? `${configuredPrefix} · ${colour}` : colour;
  };

  const previewSwatch = (swatch, target = resolveSwatchTarget(swatch)) => {
    const card = swatch.closest(cardSelector);
    if (!card) return;

    const { imageUrl, productUrl, colour } = target;
    const media = card.querySelector('[data-ss26-card-primary-media]');
    const image = media?.querySelector('img');

    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.setAttribute('src', imageUrl);
      image.setAttribute('data-src', imageUrl);
      image.alt = `${card.querySelector('.grid-product__title, .ss26-look-product__title')?.textContent.trim() || ''}／${swatch.dataset.ss26SwatchColor || ''}`;
    }

    if (productUrl) {
      swatch.setAttribute('href', productUrl);
      card.querySelectorAll('[data-ss26-card-link]').forEach((link) => {
        link.setAttribute('href', productUrl);
      });
    }

    card.querySelectorAll(swatchSelector).forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-active', selected);
      if (selected) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
    });

    syncCardColourText(card, colour);
    window.TZCardSwatches?.syncSecondary(card, swatch);
    card.classList.add('is-ss26-swatch-preview');
  };

  const activateMobileSwatch = (swatch) => {
    const card = swatch.closest(cardSelector);
    const target = resolveSwatchTarget(swatch);
    const { productUrl } = target;
    if (!card || !productUrl) return;

    if (card.dataset.ss26MobilePreviewUrl === productUrl) {
      window.location.assign(productUrl);
      return;
    }

    previewSwatch(swatch, target);
    card.dataset.ss26MobilePreviewUrl = productUrl;
  };

  const refreshThemeBehaviours = (content) => {
    prepareCardListings(content);
    content.querySelectorAll('[data-aos]').forEach((element) => {
      element.classList.add('aos-animate');
    });
    document.dispatchEvent(new CustomEvent('ss26:collection:updated', {
      detail: { content }
    }));
    window.dispatchEvent(new Event('scroll'));
  };

  const localizedCollectionUrl = (rawUrl) => {
    const url = new URL(rawUrl, window.location.origin);
    const localeRoot = window.Shopify?.routes?.root || '/';
    if (url.origin === window.location.origin && url.pathname.startsWith('/collections/') && localeRoot !== '/') {
      url.pathname = localeRoot.replace(/\/$/, '') + url.pathname;
    }
    return url;
  };

  const buildRequestUrl = (rawUrl) => {
    const requestUrl = localizedCollectionUrl(rawUrl);
    const currentUrl = new URL(window.location.href);
    const currentSort = currentUrl.searchParams.get('sort_by');
    const previewThemeId = currentUrl.searchParams.get('preview_theme_id');
    const alternateView = currentUrl.searchParams.get('view');

    requestUrl.searchParams.delete('page');
    requestUrl.searchParams.delete('section_id');
    if (currentSort) requestUrl.searchParams.set('sort_by', currentSort);
    if (previewThemeId) requestUrl.searchParams.set('preview_theme_id', previewThemeId);
    if (alternateView) requestUrl.searchParams.set('view', alternateView);
    return requestUrl;
  };

  const addGenderToCollectionUrl = (requestUrl, root, gender) => {
    if (!isTwoTierNavigation(root) || gender === 'all') return requestUrl;
    const collectionPath = localizedCollectionUrl(root.dataset.collectionUrl).pathname.replace(/\/$/, '');
    if (!requestUrl.pathname.startsWith(collectionPath)) return requestUrl;
    let suffix = requestUrl.pathname.slice(collectionPath.length).replace(/^\/+/, '');
    try { suffix = decodeURIComponent(suffix); } catch (_error) {}
    const tags = suffix.split('+').map((tag) => tag.trim()).filter((tag) => tag && tag.toLowerCase() !== 'men' && tag.toLowerCase() !== 'women');
    requestUrl.pathname = `${collectionPath}/${[gender, ...tags].join('+')}`;
    return requestUrl;
  };

  const getRequestUrls = (control, root, gender, category) => {
    const sourceTab = control.matches(genderSelector)
      ? getTabs(root).find((tab) => tab.dataset.ss26Filter === category)
      : control;
    const rawUrls = [sourceTab?.dataset.ss26FilterUrl, sourceTab?.dataset.ss26FilterUrlSecondary].filter(Boolean);
    return Array.from(new Set(rawUrls)).map((rawUrl) => addGenderToCollectionUrl(buildRequestUrl(rawUrl), root, gender));
  };

  const getNextContent = async (requestUrl, signal) => {
    const response = await fetch(requestUrl.href, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal
    });
    if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

    const html = await response.text();
    const nextDocument = new DOMParser().parseFromString(html, 'text/html');
    const nextContent = nextDocument.getElementById(contentId);
    if (!nextContent) throw new Error('Collection content was not returned');
    return nextContent;
  };

  const getAllPageContents = async (requestUrl, signal) => {
    const firstContent = await getNextContent(requestUrl, signal);
    const pageUrls = new Map();

    firstContent.querySelectorAll('.pagination a[href]').forEach((link) => {
      const pageUrl = new URL(link.getAttribute('href'), requestUrl.href);
      const page = Number(pageUrl.searchParams.get('page'));
      if (!Number.isFinite(page) || page <= 1) return;

      const normalizedUrl = buildRequestUrl(pageUrl.href);
      normalizedUrl.searchParams.set('page', String(page));
      pageUrls.set(page, normalizedUrl);
    });

    const remainingContents = await Promise.all(
      Array.from(pageUrls.entries())
        .sort(([pageA], [pageB]) => pageA - pageB)
        .map(([, pageUrl]) => getNextContent(pageUrl, signal))
    );

    return [firstContent, ...remainingContents];
  };

  const insertEditorialTiles = (grid, editorialTiles) => {
    editorialTiles.forEach(({ tile, position }) => {
      tile.dataset.ss26EditorialPosition = String(position);
      const productCards = getMerchandisingCards(grid);
      const anchor = productCards[Math.min(position, productCards.length) - 1];
      if (anchor) {
        anchor.after(tile);
      } else {
        grid.appendChild(tile);
      }
    });
  };

  const mergeGroupedContents = (contents, filter, category, gender) => {
    const primary = contents[0]?.cloneNode(true);
    if (!primary) throw new Error('Collection content was not returned');

    const primaryGrid = primary.querySelector('.product-grid-container');
    if (!primaryGrid) return { markup: primary.innerHTML, productCount: 0 };

    contents.forEach(registerEditorialTiles);
    const seenHandles = new Set();
    const seenFamilies = new Set();
    const representativeCards = [];

    if (category !== 'styling') contents.forEach((content) => {
      const campaignCards = Array.from(
        content.querySelectorAll(`.product-grid-container > ${cardSelector}`)
      );
      const sourceCards = campaignCards.length
        ? campaignCards
        : Array.from(content.querySelectorAll('.product-grid-container > .grid-product'));

      sourceCards.forEach((sourceCard) => {
        const handle = sourceCard.dataset.productHandle;
        registerCardListing(sourceCard);
        const family = sourceCard.dataset.ss26ListingFamily || handle;
        const presentation = getCardPresentation(sourceCard);
        const handleKey = `${handle}::${presentation}`;
        const familyKey = `${family}::${presentation}`;
        if (!family || seenFamilies.has(familyKey) || (handle && seenHandles.has(handleKey))) return;
        if (handle) seenHandles.add(handleKey);
        seenFamilies.add(familyKey);
        representativeCards.push(sourceCard.cloneNode(true));
      });
    });

    (extraProductLibraries.get(category) || []).forEach((sourceCard) => {
      const cardGender = sourceCard.dataset.ss26ExtraGender || 'all';
      if (gender !== 'all' && cardGender !== 'all' && cardGender !== gender) return;
      const handle = sourceCard.dataset.productHandle;
      registerCardListing(sourceCard);
      const family = sourceCard.dataset.ss26ListingFamily || handle;
      const presentation = getCardPresentation(sourceCard);
      const handleKey = `${handle}::${presentation}`;
      const familyKey = `${family}::${presentation}`;
      // The native collection card can precede the curated AW26 template.
      // Replace only those five cards so the selected cover, swatch and real
      // variant URL share the approved opening colour without reordering
      // Shopify variants or changing other Golf cards.
      if (aw26ManualOrder.has(handle)) {
        const existingIndex = representativeCards.findIndex((card) => (
          card.dataset.productHandle === handle && getCardPresentation(card) === presentation
        ));
        if (existingIndex >= 0) {
          representativeCards[existingIndex] = sourceCard.cloneNode(true);
          return;
        }
      }
      if (!family || seenFamilies.has(familyKey) || (handle && seenHandles.has(handleKey))) return;
      if (handle) seenHandles.add(handleKey);
      seenFamilies.add(familyKey);
      representativeCards.push(sourceCard.cloneNode(true));
    });

    const modalSeen = new Set();
    representativeCards.forEach((card) => {
      const modal = card.querySelector('.modal--quick-shop[data-product-id]');
      const productId = modal?.dataset.productId;
      if (!productId) return;
      if (modalSeen.has(productId)) modal.remove();
      else modalSeen.add(productId);
    });
    primaryGrid.replaceChildren(...sortMerchandisingCards(representativeCards, getRoot()));
    ensureEditorialStyles(getRoot());
    insertEditorialTiles(primaryGrid, getEditorialTiles(filter));
    primary.querySelectorAll('.pagination').forEach((pagination) => pagination.remove());
    return {
      markup: primary.innerHTML,
      productCount: representativeCards.length
    };
  };

  const syncFilterUrl = (root, gender, category) => {
    if (!isEvergreenMerchandising(root) || !isTwoTierNavigation(root)) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('gender', gender);
      url.searchParams.set('category', category);
      if (url.href !== window.location.href) {
        window.history.replaceState(window.history.state, '', url.href);
      }
    } catch (_error) {}
  };

  const loadFilter = async (control, { force = false, syncUrl = true } = {}) => {
    const root = getRoot();
    const currentContent = document.getElementById(contentId);
    if (!root || !currentContent || !control) return false;

    // A category click can arrive before a preceding gender request finishes.
    // Follow the user's pending intent, not the still-visible previous grid.
    const currentState = root.dataset.ss26PendingState
      ? { gender: root.dataset.ss26PendingGender, category: root.dataset.ss26PendingCategory }
      : getActiveState(root);
    const isGenderControl = control.matches(genderSelector);
    const requestedGender = isGenderControl ? control.dataset.ss26Gender : currentState.gender;
    const currentCategoryTab = getTabs(root).find((tab) => tab.dataset.ss26Filter === currentState.category);
    const supportedGenders = (currentCategoryTab?.dataset.ss26Genders || '').split(',');
    const requestedCategory = isGenderControl
      ? (requestedGender === 'all' || supportedGenders.includes(requestedGender) ? currentState.category : 'all')
      : control.dataset.ss26Filter;
    const gender = isTwoTierNavigation(root) ? requestedGender : 'all';
    const category = requestedCategory || 'all';
    const effectiveFilter = getEffectiveFilter(gender, category);
    const stateKey = `${gender}:${category}`;
    if (!force && root.dataset.ss26PendingState === stateKey) return null;
    if (!force && !root.dataset.ss26PendingState && root.dataset.ss26FilterState === stateKey) return true;

    const requestUrls = getRequestUrls(control, root, gender, category);
    if (!requestUrls.length) return false;
    const cacheKey = `${stateKey}:${requestUrls.map((url) => url.href).join('|')}`;
    const requestId = ++requestSequence;
    const preservedScroll = window.scrollY;
    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();
    root.dataset.ss26PendingState = stateKey;
    root.dataset.ss26PendingGender = gender;
    root.dataset.ss26PendingCategory = category;
    root.querySelectorAll(controlSelector).forEach((tab) => {
      tab.classList.remove('is-ss26-pending');
      tab.removeAttribute('aria-busy');
    });
    control.classList.add('is-ss26-pending');
    control.setAttribute('aria-busy', 'true');
    currentContent.classList.add('is-ss26-loading');
    currentContent.setAttribute('aria-busy', 'true');
    setStatus(root, getStateLabel(root, gender, category) + ': ' + ui(root, 'loading'));

    try {
      const nextResult = cache.has(cacheKey)
        ? cache.get(cacheKey)
        : mergeGroupedContents(
            category === 'styling'
              ? [await getNextContent(requestUrls[0], activeRequest.signal)]
              : (await Promise.all(requestUrls.map((requestUrl) => getAllPageContents(requestUrl, activeRequest.signal)))).flat(),
            effectiveFilter, category, gender
          );
      if (requestId !== requestSequence) return null;
      cache.set(cacheKey, nextResult);
      currentContent.innerHTML = nextResult.markup;
      const activeState = setActiveState(root, gender, category);
      refreshThemeBehaviours(currentContent);
      root.dataset.ss26LessVariantReady = 'true';
      const label = getStateLabel(root, activeState.gender, activeState.category);
      const progressiveResult = applyEvergreenProgressiveReveal(currentContent, root, label);
      if (!progressiveResult) {
        root.dataset.ss26VisibleProductCount = String(nextResult.productCount);
        root.dataset.ss26TotalProductCount = String(nextResult.productCount);
        setStatus(root, ui(root, 'count', {label, shown: nextResult.productCount}));
      }
      if (syncUrl) syncFilterUrl(root, activeState.gender, activeState.category);
      window.scrollTo({ top: preservedScroll, left: 0, behavior: 'auto' });
      return true;
    } catch (error) {
      if (error.name === 'AbortError') return null;
      console.error('[TRANZEND GOLF filters]', error);
      setStatus(root, ui(root, 'error'));
      return false;
    } finally {
      if (requestId === requestSequence) {
        currentContent.classList.remove('is-ss26-loading');
        currentContent.removeAttribute('aria-busy');
        delete root.dataset.ss26PendingState;
        delete root.dataset.ss26PendingGender;
        delete root.dataset.ss26PendingCategory;
        root.querySelectorAll(controlSelector).forEach((tab) => {
          tab.classList.remove('is-ss26-pending');
          tab.removeAttribute('aria-busy');
        });
      }
    }
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || !desktopPointer()) return;
    previewSwatch(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) previewSwatch(swatch);
  });

  document.addEventListener('touchend', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || desktopPointer()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    lastTouchActivation = performance.now();
    activateMobileSwatch(swatch);
  }, { capture: true, passive: false });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    if (desktopPointer()) {
      const { productUrl } = resolveSwatchTarget(swatch);
      if (productUrl) swatch.setAttribute('href', productUrl);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (performance.now() - lastTouchActivation < 700) return;
    activateMobileSwatch(swatch);
  }, true);

  document.addEventListener('click', async (event) => {
    const control = event.target.closest(controlSelector);
    if (!control || !control.closest(rootSelector)) return;
    event.preventDefault();
    const root = control.closest(rootSelector);
    const currentState = getActiveState(root);
    const isGenderControl = control.matches(genderSelector);
    track('ss26_collection_filter', {
      gender: isGenderControl ? control.dataset.ss26Gender : currentState.gender,
      category: isGenderControl ? 'all' : control.dataset.ss26Filter,
      source: 'collection-tabs'
    });
    await loadFilter(control);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(loadMoreSelector);
    if (!button) return;

    const root = getRoot();
    const content = document.getElementById(contentId);
    if (!root || !content || !isEvergreenMerchandising(root)) return;

    const batchSize = getEvergreenBatchSize();
    const currentVisible = Number(root.dataset.ss26VisibleProductCount) || batchSize;
    const activeState = getActiveState(root);
    const label = getStateLabel(root, activeState.gender, activeState.category);
    const result = applyEvergreenProgressiveReveal(
      content,
      root,
      label,
      currentVisible + batchSize
    );
    if (!result) return;

    track('ss26_collection_load_more', {
      filter: root.dataset.ss26ActiveFilter || 'all',
      gender: root.dataset.ss26ActiveGender || 'all',
      category: root.dataset.ss26ActiveCategory || root.dataset.ss26ActiveFilter || 'all',
      visible_count: result.visibleCount,
      total_count: result.totalCount,
      source: 'collection-grid'
    });
    if (event.detail === 0) {
      const grid = content.querySelector('.product-grid-container');
      const firstNewCard = getMerchandisingCards(grid)[currentVisible];
      const firstNewLink = firstNewCard && !firstNewCard.hidden
        ? firstNewCard.querySelector('[data-ss26-card-link][href], a.grid-product__link[href]')
        : null;
      if (firstNewLink) {
        firstNewLink.focus();
        return;
      }
    }
    content.querySelector(loadMoreSelector)?.focus({ preventScroll: true });
  });

  document.addEventListener('click', async (event) => {
    const lookLink = event.target.closest(lookFilterSelector);
    if (!lookLink) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const root = getRoot();
    if (!root) return;
    const filter = lookLink.dataset.ss26LookFilter;
    const control = isTwoTierNavigation(root) && (filter === 'men' || filter === 'women')
      ? getGenderTabs(root).find((item) => item.dataset.ss26Gender === filter)
      : getTabs(root).find((item) => item.dataset.ss26Filter === filter);
    if (!control) return;
    track('ss26_shop_by_look', { filter, source: lookLink.dataset.ss26TrackSource || 'campaign' });
    const loaded = await loadFilter(control);
    if (loaded !== true) return;
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    control.focus({ preventScroll: true });
  });

  document.addEventListener('click', async (event) => {
    const editorialLink = event.target.closest(editorialSelector);
    if (!editorialLink) return;
    const editorialItem = editorialLink.closest('[data-ss26-editorial-id]');
    const targetFilter = editorialLink.dataset.ss26EditorialTargetFilter;
    track('ss26_editorial_click', { editorial_id: editorialItem?.dataset.ss26EditorialId || 'unknown', destination: targetFilter || editorialLink.getAttribute('href') || '' });
    if (!targetFilter) return;
    const root = getRoot();
    const control = root && (isTwoTierNavigation(root) && (targetFilter === 'men' || targetFilter === 'women')
      ? getGenderTabs(root).find((item) => item.dataset.ss26Gender === targetFilter)
      : getTabs(root).find((item) => item.dataset.ss26Filter === targetFilter));
    if (!root || !control) return;
    event.preventDefault();
    const loaded = await loadFilter(control);
    if (loaded !== true) return;
    root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    control.focus({ preventScroll: true });
  });

  const queueKeyboardActivation = (control) => {
    window.clearTimeout(keyboardActivationTimer);
    keyboardActivationTimer = window.setTimeout(() => {
      const root = control.closest(rootSelector);
      const state = root ? getActiveState(root) : { gender: 'all', category: 'all' };
      track('ss26_collection_filter', {
        gender: control.matches(genderSelector) ? control.dataset.ss26Gender : state.gender,
        category: control.matches(genderSelector) ? 'all' : control.dataset.ss26Filter,
        source: 'collection-tabs-keyboard'
      });
      loadFilter(control);
    }, 80);
  };

  document.addEventListener('keydown', (event) => {
    const control = event.target.closest(controlSelector);
    const root = control?.closest(rootSelector);
    if (!root) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      queueKeyboardActivation(control);
      return;
    }
    const controls = getVisibleControls(root, control.matches(genderSelector) ? genderSelector : tabSelector);
    const currentIndex = controls.indexOf(control);
    let nextIndex = currentIndex;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % controls.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + controls.length) % controls.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = controls.length - 1;
    if (nextIndex === currentIndex || nextIndex < 0) return;
    event.preventDefault();
    controls[nextIndex].focus({ preventScroll: true });
    queueKeyboardActivation(controls[nextIndex]);
  });

  const readyRoot = getRoot();
  if (readyRoot) {
    sortMerchandisingGrid(document.querySelector(`#${contentId} .product-grid-container`), readyRoot);
    prepareCardListings(document);
    registerEditorialTiles(document);
    registerExtraProducts();
    readyRoot.dataset.ss26ScriptReady = 'true';
    readyRoot.dataset.ss26ProductPreviewReady = 'true';
    const initialFilter = readyRoot.dataset.ss26ActiveFilter || 'all';
    // G34 navigation deep links use the existing gender/category filter contract.
    const navigationParams = new URLSearchParams(window.location.search);
    const requestedGender = navigationParams.get('gender');
    const requestedCategory = navigationParams.get('category') === 'styling' ? 'new' : navigationParams.get('category');
    const validGender = getGenderTabs(readyRoot).some(tab => tab.dataset.ss26Gender === requestedGender);
    const validCategory = getTabs(readyRoot).some(tab => tab.dataset.ss26Filter === requestedCategory);
    const initialGender = (validGender ? requestedGender : '') || readyRoot.dataset.ss26ActiveGender || (initialFilter === 'men' || initialFilter === 'women' ? initialFilter : 'all');
    const initialCategory = (validCategory ? requestedCategory : '') || readyRoot.dataset.ss26ActiveCategory || (initialGender === 'all' ? initialFilter : 'all');
    const activeState = setActiveState(readyRoot, initialGender, initialCategory);
    const activeControl = activeState.category === 'all' && activeState.gender !== 'all' ? activeState.activeGenderTab : activeState.categoryTab;
    const serverGrid = document.querySelector(`#${contentId} .product-grid-container[data-ss26-server-canonical="true"]`);
    const requiresMergedSources = activeState.category === 'bottoms' || activeState.category === 'skirt';
    const requiresInitialEvergreenHydration = isEvergreenMerchandising(readyRoot);
    if (serverGrid && !requiresMergedSources && !requiresInitialEvergreenHydration) {
      const serverCards = serverGrid.querySelectorAll(cardSelector);
      readyRoot.dataset.ss26LessVariantReady = 'server';
      readyRoot.dataset.ss26VisibleProductCount = String(serverCards.length);
      readyRoot.dataset.ss26TotalProductCount = String(serverCards.length);
      setStatus(readyRoot, ui(readyRoot, 'count', {label: getStateLabel(readyRoot, activeState.gender, activeState.category), shown: serverCards.length}));
    } else if (activeControl) {
      const hydrate = () => loadFilter(activeControl, { force: true, syncUrl: false });
      if (requiresInitialEvergreenHydration) {
        hydrate();
      } else if ('IntersectionObserver' in window) {
        const hydrationObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          hydrationObserver.disconnect();
          hydrate();
        }, { rootMargin: '600px 0px' });
        hydrationObserver.observe(readyRoot);
      } else {
        hydrate();
      }
    }
  }
})();


